// extracted by mini-css-extract-plugin
module.exports = {"richtext":"embed_richtext__E0kL0"};